import { render } from "./SunburstDiagram.vue?vue&type=template&id=2a14d030"
import script from "./SunburstDiagram.vue?vue&type=script&lang=ts"
export * from "./SunburstDiagram.vue?vue&type=script&lang=ts"
script.render = render

export default script